import { useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useAdvisor, INITIAL } from "@/advisor/AdvisorContext";
import { useBusinessSubmit } from "@/advisor/useBusinessSubmit";
import { StepInput } from "./StepInput";
import { StepGoals } from "./StepGoals";
import { StepTools } from "./StepTools";
import { StepTiktok } from "./StepTiktok";
import { Analyzing } from "./Analyzing";
import { Results } from "./Results";

export const Advisor = ({ hero, footer, compact, onNavigate }) => {
  const { state, update } = useAdvisor();
  const { submit, loading } = useBusinessSubmit();
  const ref = useRef(null);

  const go = (step) => {
    update({ step });
    setTimeout(() => ref.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
  };

  const submitBusiness = async () => {
    await submit();
    setTimeout(() => ref.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
  };

  const restart = () => {
    update({ ...INITIAL, selected: state.selected, extraRecommended: state.extraRecommended });
    go("input");
  };

  const views = {
    input: <>{hero}<StepInput onSubmit={submitBusiness} loading={loading} />{footer}</>,
    goals: <StepGoals onBack={() => go("input")} onNext={() => go("tools")} />,
    tools: <StepTools onBack={() => go("goals")} onNext={() => go("analyzing")} />,
    tiktok: <StepTiktok onBack={() => go("input")} onNext={() => go("analyzing")} />,
    analyzing: <Analyzing onDone={() => go("results")} onFail={() => go("input")} />,
    results: <Results onRestart={restart} compact={compact} onNavigate={onNavigate} />,
  };

  return (
    <div ref={ref} className="scroll-mt-28" data-testid="advisor-root">
      <AnimatePresence mode="wait">
        <motion.div key={state.step} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.25 }}>
          {views[state.step] || views.input}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
